import { render } from "./CompanyCommunication.vue?vue&type=template&id=0b35535f&scoped=true&ts=true&lang=pug"
import script from "./CompanyCommunication.vue?vue&type=script&lang=ts"
export * from "./CompanyCommunication.vue?vue&type=script&lang=ts"

import "./CompanyCommunication.vue?vue&type=style&index=0&id=0b35535f&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b35535f"]])

export default __exports__